import { Component } from '@/types'

type PendingAdd = {
  items: Array<{ id: string | number; quantity: number }>
}

let pendingAdd: PendingAdd | null = null
let onAfterAdd: ((result: unknown) => void) | null = null

async function emptyCart() {
  await fetch('/cart/clear.js', { method: 'POST' })
}

async function addToCart(data: PendingAdd) {
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  })
  return res.json()
}

function closeModal() {
  const modal = document.querySelector(
    '[data-ref="cart-validation-modal"]'
  ) as HTMLElement | null
  if (modal) modal.style.display = 'none'
  pendingAdd = null
  onAfterAdd = null
}

async function replaceCartWithPending() {
  if (!pendingAdd) {
    closeModal()
    return
  }

  const itemToAdd = pendingAdd
  const callback = onAfterAdd

  closeModal()

  await emptyCart()
  const result = await addToCart(itemToAdd)

  window.dispatchEvent(
    new CustomEvent('se-event.cart.product-added', { detail: result })
  )

  if (callback) callback(result)
}

const component: Component = ref => {
  if (!ref.cartValidationModal) return

  ref.cartValidationModal.forEach((modal: HTMLElement) => {
    const keepButtons = modal.querySelectorAll(
      '[data-ref="cart-validation-keep"]'
    )
    const replaceButton = modal.querySelector(
      '[data-ref="cart-validation-replace"]'
    )
    const bg = modal.querySelector('.bg')

    keepButtons.forEach(button => {
      button.addEventListener('click', closeModal)
    })

    replaceButton?.addEventListener('click', replaceCartWithPending)
    bg?.addEventListener('click', closeModal)

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && modal.style.display !== 'none') {
        closeModal()
      }
    })
  })
}

export function showCartValidationModal(opts?: {
  pendingAdd?: PendingAdd
  onAfterAdd?: (result: unknown) => void
}) {
  pendingAdd = opts?.pendingAdd || null
  onAfterAdd = opts?.onAfterAdd || null

  const modal = document.querySelector(
    '[data-ref="cart-validation-modal"]'
  ) as HTMLElement | null
  if (modal) modal.style.display = 'block'
}

export default component
